var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGo = function SvgGo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.25 14.567C22.5833 14.7595 22.5833 15.2406 22.25 15.433L9.75 22.6499C9.41667 22.8424 9 22.6018 9 22.2169L9 7.78314C9 7.39824 9.41667 7.15768 9.75 7.35013L22.25 14.567Z"
  })));
};
export default SvgGo;